import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CoacheeProfileMeetingsController } from 'presentation/page/profile/coachee-profile/coachee-profile-meetings/coachee-profile-meetings.controller';

@Component({
	selector: 'spr-coachee-profile-meetings-header',
	templateUrl: './coachee-profile-meetings-header.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class:
			'md:flex hidden md:flex-none md:items-center md:bg-grey-alabaster md:p-3 md:space-x-3',
	},
})
export class CoacheeProfileMeetingsHeaderComponent {
	constructor(public controller: CoacheeProfileMeetingsController) {}
}
